import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { ArrowDownIcon } from '@shared/icons/arrow-down';
import { ApplicationView } from '@shared/enums';
import { isDefaultView } from '@shared/utils/applications';

type Props = {
  view: ApplicationView;
  isCollapsed: boolean;
  onClick: () => void;
} & React.HTMLAttributes<HTMLDivElement>;

export const ApplicationCardCollapseController = ({ view, onClick, isCollapsed, className }: Props) => {
  const { t } = useTranslation();

  const text = isDefaultView(view) ? 'show-needs' : 'show-letter';

  return (
    <div onClick={onClick} className={clsx(className, 'cursor-pointer', 'items-center', 'text-xs')}>
      {t(text)}
      <ArrowDownIcon width={12} height={24} className={clsx({ 'rotate-180': !isCollapsed }, 'ml-2')} />
    </div>
  );
};
